import type { ReactElement } from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ThemeSyncBadgeProps {
  onRetry: () => void;
  isRetrying: boolean;
}

export function ThemeSyncBadge({
  onRetry,
  isRetrying,
}: ThemeSyncBadgeProps): ReactElement {
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="theme-sync-badge"
      className="mt-3 flex items-center gap-2 text-[13px] text-destructive"
    >
      <AlertCircle className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <span className="flex-1">
        Couldn&apos;t sync your theme to your account.
      </span>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onRetry}
        disabled={isRetrying}
      >
        {isRetrying ? 'Syncing…' : 'Retry'}
      </Button>
    </div>
  );
}
